import { render, staticRenderFns } from "./CloseTaskDialog.vue?vue&type=template&id=1990bc0b&scoped=true"
import script from "./CloseTaskDialog.vue?vue&type=script&lang=js"
export * from "./CloseTaskDialog.vue?vue&type=script&lang=js"
import style0 from "./CloseTaskDialog.vue?vue&type=style&index=0&id=1990bc0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1990bc0b",
  null
  
)

export default component.exports